import { TableContainer } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { IS_LOCAL_ENV } from "../App";

const CustomTable = ({
  children,
  scrollPos,
  setShowScroll,
  setScrollPos,
  customMaxWidth,
}) => {
  //scroll pos recibe el valor[0-100] al que se debe mover el scroll interno de la tabla
  //setShowScroll le dice al componente padre que debe mostrar el scroll

  const tableContainerRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [pxDistance, setPxDistance] = useState(-1);
  //========func=================
  const checkOverflow = () => {
    if (tableContainerRef.current) {
      let anchoTabla = tableContainerRef.current.scrollWidth;
      let anchoCliente = tableContainerRef.current.clientWidth;
      const io = anchoTabla > anchoCliente;
      IS_LOCAL_ENV && console.log("ancho scroll: ", anchoTabla);
      IS_LOCAL_ENV && console.log("ancho cliente: ", anchoCliente);
      setPxDistance(anchoTabla - anchoCliente);
      IS_LOCAL_ENV && console.log(io);
      setIsOverflowing(io);
      const pxDesp = tableContainerRef.current.scrollLeft;
      IS_LOCAL_ENV &&
        console.log("left:", tableContainerRef.current.scrollLeft);
      const perc = (pxDesp * 100) / anchoTabla;
      setScrollPos(perc);
    }
  };
  //=============================
  useEffect(() => {
    //verificar espacio de iconos no establecidos
    //bug de la imagen
    //demora al cargar la fuente
    setTimeout(() => {
      checkOverflow();
    }, 1500);

    window.addEventListener("resize", checkOverflow);
    return () => {
      window.removeEventListener("resize", checkOverflow);
    };
  }, []);

  useEffect(() => {
    setShowScroll(isOverflowing);
  }, [isOverflowing]);

  useEffect(() => {
    //logica para mover
    const distance_to_move = (scrollPos / 100) * pxDistance;
    tableContainerRef.current.scrollTo(distance_to_move, 0);
  }, [scrollPos]);

  return (
    <TableContainer
      ref={tableContainerRef}
      //style={{ overflow: "hidden" }}
      className={`  w-full scrollbar-hide  shadow-md border-[1px] border-accent-green rounded-[10px] ${
        customMaxWidth ? customMaxWidth : "max-w-[1280px]"
      } `}
    >
      {children}
    </TableContainer>
  );
};

export default CustomTable;
